/*
 * Copyright (c) 2020 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { FormatterProvider, LocaleProvider, NumberFormatterOptions, ValidationProvider } from '@typescript-kit/core';
import { TimeRecordingValidationKey } from './key/time-recording-validation.key';
import { validateTimeRecordProject } from './validation/time-record-project.validation-predicate';
import { HoursFormatter } from './formatter/hours.formatter';
import { TimeRecordingFormatterKey } from './key/time-recording-formatter.key';

import { timeRecordingDeLocale } from './locale/de.locale';

export class TimeRecordingInitializer {

  static initialize() {
    TimeRecordingInitializer.registerLocales();
    TimeRecordingInitializer.registerFormatterFactories();
    TimeRecordingInitializer.registerValidationPredicates();
  }

  static registerLocales() {
    LocaleProvider.registerPackageLocale('de', 'time-recording', timeRecordingDeLocale);
  }

  static registerFormatterFactories() {
    const hoursFormatterFactory = (options?: NumberFormatterOptions) => new HoursFormatter(options);
    FormatterProvider.registerFormatterFactory('hours', hoursFormatterFactory);
    FormatterProvider.registerFormatterFactory(TimeRecordingFormatterKey.HOURS, hoursFormatterFactory);
  }

  static registerValidationPredicates() {
    ValidationProvider.registerPredicate(TimeRecordingValidationKey.TIME_RECORD_PROJECT, validateTimeRecordProject);
  }
}
